import { PRO_WORLDS, PRO_TOTAL } from "../../data/proWorlds";

export default function ProProgressScreen({progress}){
  const done=Object.keys(progress).length;
  const pct=Math.round(done/PRO_TOTAL*100);
  return(
    <div style={{fontFamily:"Nunito",background:"#0f172a",minHeight:"100vh",padding:"16px",paddingBottom:100}}>
      <div style={{background:"linear-gradient(135deg,#0ea5e9,#8b5cf6)",borderRadius:20,padding:"20px",
        marginBottom:16,textAlign:"center"}}>
        <div style={{fontSize:44,marginBottom:8}}>📊</div>
        <div style={{fontSize:22,fontWeight:900,color:"#fff",fontFamily:"Fredoka One"}}>Your Progress</div>
        <div style={{fontSize:32,fontWeight:900,color:"#fff",margin:"8px 0"}}>{pct}%</div>
        <div style={{background:"#ffffff33",borderRadius:20,height:10,overflow:"hidden"}}>
          <div style={{height:"100%",background:"#fff",borderRadius:20,width:`${pct}%`,transition:"width 0.7s"}}/>
        </div>
        <div style={{fontSize:13,color:"#ffffffcc",marginTop:6,fontWeight:700}}>{done} of {PRO_TOTAL} lessons complete</div>
      </div>
      {PRO_WORLDS.map(w=>{
        const d=w.lessons.filter((_,i)=>progress[`${w.id}-${i}`]).length;
        const p=d/w.lessons.length;
        return(
          <div key={w.id} style={{background:"#1e293b",borderRadius:16,padding:"14px",marginBottom:10,border:`1px solid ${w.color}33`}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
              <div style={{fontSize:14,fontWeight:800,color:"#f1f5f9"}}>{w.emoji} {w.label}</div>
              <div style={{fontSize:13,fontWeight:900,color:w.color}}>{d}/{w.lessons.length}</div>
            </div>
            <div style={{background:"#0f172a",borderRadius:20,height:8,overflow:"hidden"}}>
              <div style={{width:`${p*100}%`,height:"100%",background:`linear-gradient(90deg,${w.color},${w.dark})`,borderRadius:20,transition:"width 0.6s"}}/>
            </div>
          </div>
        );
      })}
    </div>
  );
}
